import './ClockLoader.less';

export type Props = {
	duration?: number;
	size?: number;
	color1?: string; // The filler and border color
	color2?: string; // The background color
};

export function ClockLoader({ duration = 2, size = 40, color1 = '#bfc3c8', color2 = '#fff' }: Props) {
	return (
		<svg
			data-test="clock-loader"
			class="clock-loader"
			width="100"
			height="100"
			viewBox="0 0 100 100"
			style={`--clock-loader-duration: ${duration}s;--clock-loader-size:${size}px;--clock-loader-color-1:${color1};--clock-loader-color-2:${color2}`}
		>
			<circle class="clock-loader__backdrop" r="50" cx="50" cy="50" />
			<circle class="clock-loader__spinner" stroke-width="50" fill="transparent" r="25" cx="50" cy="50" />
			<circle
				class="clock-loader__frontdrop"
				stroke="#bfc3c8"
				stroke-width="8"
				fill="transparent"
				r="46"
				cx="50"
				cy="50"
			/>
		</svg>
	);
}
